import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, withKeys as _withKeys, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/arrow_down2.svg'


const _withScopeId = n => (_pushScopeId("data-v-bceb5a32"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "tw-border tw-border-[#EFF0F1] tw-border-solid tw-rounded-[6px]" }
const _hoisted_2 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-[62px]"
}
const _hoisted_3 = ["id", "data-cy"]
const _hoisted_4 = { class: "tw-flex tw-flex-row tw-justify-start tw-items-center tw-h-[59px]" }
const _hoisted_5 = { class: "tw-px-[25px] tw-py-[20px] tw-font-Poppins tw-text-[15px] tw-font-[600] tw-text-[#211F58]" }
const _hoisted_6 = ["id"]
const _hoisted_7 = { class: "float-right button-arrow dropdown-button-arrow-img" }
const _hoisted_8 = {
  key: 0,
  class: "dropdown-button-arrow-img",
  src: _imports_0
}
const _hoisted_9 = {
  key: 1,
  class: "collap-button-arrow-down-img",
  src: _imports_0
}
const _hoisted_10 = {
  key: 0,
  class: "custom-global-skeleton tw-w-full tw-h-[62px]"
}
const _hoisted_11 = { class: "tw-flex tw-gap-[10px] tw-items-center tw-flex-wrap" }
const _hoisted_12 = ["id", "value", "onKeyup", "onBlur"]
const _hoisted_13 = ["id", "data-cy"]
const _hoisted_14 = ["id"]
const _hoisted_15 = { class: "tw-flex tw-gap-[15px] tw-items-center" }
const _hoisted_16 = {
  key: 0,
  class: "tw-flex tw-gap-[15px] tw-items-center"
}
const _hoisted_17 = {
  key: 0,
  class: "tw-text-[#878787] tw-text-[13px] tw-font-[400]"
}
const _hoisted_18 = ["data-cy"]
const _hoisted_19 = ["data-cy"]

import { Ref, computed, onMounted, ref } from "vue";
import {
  checklistRequestedStatusId,
  CHECKLISTSTATUS,
  checklistStatusId,
} from "@/utils/constants";
import { convertUTCTimeToLocalTime } from "@/utils/dateTimeUtils";
import { downloadCSV, getComponentUiText } from "@/utils/utilities";
import store from "@/store";
import { useRouter } from "vue-router";
import popoverAssessment from "../assessment/popoverAssessment.vue";
import { IChecklistRequested } from "@/interfaces/vendor";
import { showErrorAPI, showSuccessToast } from "@/services/apiRoutes";
import { Checklist, Vendor } from "@/services/apiRoutes/routes";
import EventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { putChecklistRequested } from "@/services/vendor";
import { getAssessmentItemsCSV } from "@/services/assessment";
import dayjs from "dayjs";
import CustomDropDownItem from "../common/customDropDownItem.vue";

interface Option {
  id: number;
  arrowRed: boolean;
  statusTag: string;
  statusTagId: string;
  dataCy: (item: any) => string;
  text: (item: any) => string;
  isShow: (item: any) => boolean;
  action: (item: any) => void;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'vendorAssessmentHistory',
  props: {
  assessments: {
    type: Array as () => IChecklistRequested[],
    default: () => [],
  },
  assessmentName: { type: String, default: "" },
  checklistId: { type: Number, default: 0 },
  checklistRequestedId: { type: Number, default: 0 },
},
  emits: [
  "onRefresh",
  "onChangeRecipient",
  "onSetInprogress",
  "onDeleteAssessment",
],
  setup(__props, { emit }) {

const props = __props;

const isCallApiUpdate = ref(false);

const router = useRouter();




const statusAssessment = {};

statusAssessment[checklistRequestedStatusId.inProgress] = {
  className: "checkListRequestedInprogress",
  label: getComponentUiText(
    "app-component-assessments-checklist-requested-status-inprogress-1",
  ),
};
statusAssessment[checklistRequestedStatusId.created] = {
  className: "checkListRequestedCreated",
  label: getComponentUiText(
    "app-component-assessments-checklists-requested-status-created-1",
  ),
};
statusAssessment[checklistRequestedStatusId.completed] = {
  className: "checkListRequestedCompleted",
  label: getComponentUiText(
    "app-component-assessments-checklists-requested-status-completed-1",
  ),
};
statusAssessment[checklistRequestedStatusId.waiting] = {
  className: "checkListRequestedWait",
  label: getComponentUiText(
    "app-component-assessments-checklist-requested-status-waiting-1",
  ),
};
statusAssessment[checklistRequestedStatusId.submitted] = {
  className: "checkListRequestedSubmited",
  label: getComponentUiText(
    "app-component-assessments-checklists-requested-status-submitted-1",
  ),
};
const popoverAssessmentRef: Ref = ref(false);

const subMenuOptions: Ref<Option[]> = ref([
  {
    id: 1,
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    dataCy: (item) =>
      `vendor-assessment-history-submenu-restore-assessment-${item.checklistRequestedId}`,
    text: () =>
      "app-vendor-assessment-manage-submenu-restore-assessment-option-1",
    isShow: (item) => item.isArchived === true,
    action: (item) => handleRestoreAssessment(item.checklistRequestedId),
  },
  {
    id: 2,
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    dataCy: (item) =>
      `vendor-assessment-history-submenu-view-assessment-${item.checklistRequestedId}`,
    text: (item) =>
      item.statusId === checklistStatusId.completed ||
      item.statusId === checklistStatusId.created
        ? "app-component-assessment-detail-dropdown-option-view-assessment-title-1"
        : "app-component-assessment-detail-review-button",
    isShow: (item) => item.isArchived === false,
    action: (item) => viewAssessment(item.checklistRequestedId),
  },
  {
    id: 3,
    arrowRed: false,
    statusTag: CHECKLISTSTATUS.SUBMITTED,
    statusTagId: CHECKLISTSTATUS.SUBMIT,
    dataCy: () => "",
    text: () => "app-component-dropdown-set-assessment-to-1",
    isShow: (item) =>
      item.isArchived === false &&
      item.statusId === checklistStatusId.completed,
    action: (item) => handleReadyToReviewAssessment(item.checklistRequestedId),
  },
  {
    id: 4,
    arrowRed: false,
    statusTag: CHECKLISTSTATUS.COMPLETED,
    statusTagId: CHECKLISTSTATUS.DONE,
    dataCy: () => "",
    text: () => "app-component-dropdown-set-assessment-to-1",
    isShow: (item) =>
      item.isArchived === false &&
      item.statusId !== checklistStatusId.completed,
    action: (item) => handleCompleteAssessment(item.checklistRequestedId),
  },
  {
    id: 5,
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    dataCy: () => "",
    text: () =>
      "app-vendor-assessment-manage-submenu-rename-assessment-option-1",
    isShow: (item) => item.isArchived === false,
    action: (item) => handleRenameAssessment(item),
  },
  {
    id: 6,
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    dataCy: () => "",
    text: () =>
      "app-vendor-assessment-manage-submenu-change-recipient-option-1",
    isShow: (item) => item.isArchived === false,
    action: (item) => {
      emit("onChangeRecipient", item);
    },
  },
  // {
  //   id: 7,
  //   text: "app-vendor-assessment-manage-submenu-set-inprogress-option-1",
  //   isShow: (item) => item.isArchived === false && item.statusId !== CHECKLISTSTATUS.INPROG,
  //   action: (item) => {
  //     popoverAssessmentRef.value.popoverShow = false;
  //     emit("onSetInprogress", item);
  //   },
  // },
  {
    id: 8,
    arrowRed: false,
    statusTag: "",
    statusTagId: "",
    dataCy: () => "",
    text: () =>
      "app-vendor-assessment-manage-submenu-download-assessment-option-1",
    isShow: (item) => item.isArchived === false,
    action: (item) => handleDownloadAssessment(item),
  },
  {
    id: 9,
    arrowRed: true,
    statusTag: "",
    statusTagId: "",
    dataCy: (item) =>
      `vendor-assessment-history-submenu-delete-assessment-${item.checklistRequestedId}`,
    text: () => "app-vendor-assessment-btn-delete-assessment-1",
    isShow: (item) => item.isArchived === false,
    action: (item) => handleDeleteAssessment(item.checklistRequestedId),
  },
]);

const showIcon: Ref<boolean> = ref(true);
const totalHistory = computed(() => checklistAssessmentHistory.value.length);
const isDataLoading: Ref<boolean> = ref(true);
const updateAssessmentNameId: Ref<number> = ref(0);

const checklistAssessmentHistory = computed(() => {
  return props.assessments;
});
const isChecklistAssessmentHistoryLoading: Ref<boolean> = computed(() => {
  return Object.keys(checklistAssessmentHistory).length === 0;
});

onMounted(() => {
  isDataLoading.value = false;
});

const getScoreByChecklistId = (checklistId) => {
  const scorePcnt = checklistAssessmentHistory.value.find(
    (item) => item.checklistRequestedId === checklistId,
  )?.scorePcnt;
  return parseFloat((scorePcnt ?? 0).toFixed(1));
};

const handleDeleteAssessment = async (checklistRequestedId) => {
  try {
    const res = await store.dispatch("Vendor/updateChecklistRequested", {
      params: {
        checklistRequestedIsArchived: true,
      },
      checklistRequestedId,
    });
    if (res) {
      emit("onDeleteAssessment");
      showSuccessToast(
        getComponentUiText("app-vendor-assessment-delete-assessment-success-1"),
      );
    }
  } catch (error) {
    showErrorAPI(error, Vendor.putRequestedAssessment);
  }
};
const handleRenameAssessment = async (item) => {
  EventEmitter.emit(EmitterEvents.HIDDEN_SETTINGS);
  updateAssessmentNameId.value = item.checklistRequestedId;
  const idName = `vendor-assessment-history-input-rename-${item.checklistRequestedId}`;
  setTimeout(() => {
    document.getElementById(idName)?.focus();
  }, 300);
};

const onRenameAssessment = async (e, index) => {
  updateAssessmentNameId.value = 0;
  if (!e.target.value) return;
  if (isCallApiUpdate.value) return;

  isCallApiUpdate.value = true;
  store.dispatch("Vendor/updateChecklistRequested", {
    checklistRequestedId:
      checklistAssessmentHistory.value[index]["checklistRequestedId"],
    params: {
      checklistRequestedName: e.target.value,
    },
  });
  setTimeout(() => {
    isCallApiUpdate.value = false;
  }, 100);
};

const collapseCategory = () => (showIcon.value = !showIcon.value);

const viewAssessment = (checklistRequestedId) => {
  router.push({
    name: "AssessmentVendorReview",
    params: { assessmentId: checklistRequestedId },
  });
};

const handleDownloadAssessment = async (item: IChecklistRequested) => {
  try {
    const res = await getAssessmentItemsCSV(item.checklistRequestedId);
    downloadCSV(
      res,
      `CyberSystem_Assessment_Export_${dayjs().format("YYYYMMDD_HHmmss")}_${
        item.name
      }.csv`,
    );
    if (res) {
      showSuccessToast(
        getComponentUiText(
          "app-vendor-assessment-download-assessment-success-1",
        ),
      );
    }
    popoverAssessmentRef.value.popoverShow = false;
  } catch (error) {
    showErrorAPI(error, Checklist.getAssessmentItemsCSV);
  }
};

const handleRestoreAssessment = async (checklistRequestedId) => {
  try {
    popoverAssessmentRef.value.popoverShow = false;

    const res = await store.dispatch("Vendor/updateChecklistRequested", {
      params: {
        checklistRequestedIsArchived: false,
      },
      checklistRequestedId,
    });

    if (!res) return;

    showSuccessToast(
      getComponentUiText("app-vendor-assessment-restore-assessment-success-1"),
    );
  } catch (error) {
    showErrorAPI(error, Vendor.putRequestedAssessment);
  }
};

const handleCompleteAssessment = async (checklistRequestedId) => {
  const body = { checklistRequestedStatusId: CHECKLISTSTATUS.DONE };
  const params = {
    checklistRequestedId,
  };

  try {
    await store.dispatch("Vendor/postChecklistRequestedStatus", {
      params,
      body,
      isNoneLoading: true,
      onlyUpdateStatus: true,
    });

    showSuccessToast(
      getComponentUiText(
        "app-vendor-assessment-set-assessment-complete-success-1",
      ),
    );

    await store.dispatch("Vendor/fetchRequestedChecklist", {
      isArchived: false,
    });
  } catch (error: any) {
    showErrorAPI(error, Vendor.postChecklistRequestedStatus);
  }
};

const handleReadyToReviewAssessment = async (checklistRequestedId) => {
  const body = { checklistRequestedStatusId: CHECKLISTSTATUS.SUBMIT };
  const params = {
    checklistRequestedId,
  };

  try {
    await store.dispatch("Vendor/postChecklistRequestedStatus", {
      params,
      body,
      isNoneLoading: true,
      onlyUpdateStatus: true,
    });

    showSuccessToast(
      getComponentUiText(
        "app-vendor-assessment-set-assessment-ready-review-success-1",
      ),
    );

    await store.dispatch("Vendor/fetchRequestedChecklist", {
      isArchived: false,
    });
  } catch (error: any) {
    showErrorAPI(error, Vendor.postChecklistRequestedStatus);
  }
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isDataLoading.value)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2))
      : (_openBlock(), _createElementBlock("div", {
          key: 1,
          id: `vendor-assessment-history-${__props.checklistRequestedId}`,
          class: _normalizeClass(`tw-cursor-pointer tw-select-none tw-pr-[25px] tw-bg-[#FCFCFD] tw-w-full tw-flex tw-flex-row tw-justify-between tw-items-center tw-self-stretch tw-border-0  tw-border-solid tw-border-[#EFF0F1]
          ${
            showIcon.value
              ? 'tw-rounded-[6px]'
              : 'tw-rounded-t-[6px] tw-border-b-[1px]'
          }`),
          "data-cy": `vendor-assessment-history-${__props.checklistRequestedId}`,
          onClick: collapseCategory
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
              "app-component-assessment-existing-assessment-dropdown-subtitle-assessment-history-1",
            )) + " ", 1),
              _createElementVNode("span", {
                id: `vendor-assessment-history-total-${__props.checklistRequestedId}`,
                class: "tw-font-[400]"
              }, "(" + _toDisplayString(totalHistory.value) + ")", 9, _hoisted_6)
            ])
          ]),
          _createElementVNode("div", null, [
            _createElementVNode("span", _hoisted_7, [
              (showIcon.value)
                ? (_openBlock(), _createElementBlock("img", _hoisted_8))
                : (_openBlock(), _createElementBlock("img", _hoisted_9))
            ])
          ])
        ], 10, _hoisted_3)),
    _withDirectives(_createElementVNode("div", null, [
      (isChecklistAssessmentHistoryLoading.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_10))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(checklistAssessmentHistory.value as any, (item, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "tw-flex tw-justify-between tw-items-center tw-px-[25px] tw-py-[20px] tw-self-stretch tw-border-0 tw-border-b-[1px] tw-border-solid tw-border-[#EFF0F1] tw-flex-wrap"
        }, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", null, [
              (updateAssessmentNameId.value === item.checklistRequestedId)
                ? (_openBlock(), _createElementBlock("input", {
                    key: 0,
                    id: `vendor-assessment-history-input-rename-${item.checklistRequestedId}`,
                    value: item.name,
                    type: "text",
                    class: "tw-rounded-md tw-w-[150px] tw-border tw-border-solid tw-border-[#EFF0F1] tw-py-[5px] tw-px-[10px] tw-text-[15px] tw-font-[400] tw-text-[#211F58] tw-mr-2",
                    onKeyup: _withKeys((e) => onRenameAssessment(e, index), ["enter"]),
                    onBlur: (e) => onRenameAssessment(e, index)
                  }, null, 40, _hoisted_12))
                : (_openBlock(), _createElementBlock("span", {
                    key: 1,
                    id: `vendor-assessment-history-name-${item.checklistRequestedId}`,
                    "data-cy": `vendor-assessment-history-name-${item.checklistRequestedId}`,
                    class: _normalizeClass(`${
                item.isArchived ? 'tw-text-[#878787]' : 'tw-text-[#211F58]'
              } tw-text-[13px] tw-font-medium tw-font-[Poppins]`)
                  }, _toDisplayString(item.name), 11, _hoisted_13)),
              (item.dateAdded)
                ? (_openBlock(), _createElementBlock("span", {
                    key: 2,
                    id: `vendor-assessment-history-dateAdded-${item.checklistRequestedId}`,
                    class: "tw-text-[13px] tw-text-[#878787]"
                  }, " - " + _toDisplayString(_unref(convertUTCTimeToLocalTime)(item.dateAdded)), 9, _hoisted_14))
                : _createCommentVNode("", true)
            ]),
            _withDirectives(_createElementVNode("div", { class: "tw-text-[#878787] tw-border tw-border-solid tw-border-[#EFF0F1] tw-px-[5px] tw-py-[3px] cell-status tw-flex tw-items-center tw-text-[11px] tw-font-[500] tw-rounded-[4px]" }, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessment-history-label-state-1",
              )), 513), [
              [_vShow, index === 0]
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            (!item.isArchived)
              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                  (item.status !== _unref(checklistStatusId).defunct)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(getScoreByChecklistId(item.checklistId)) + "% ", 1))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass([statusAssessment[item.statusId]?.className, "tw-px-[5px] tw-py-[3px] cell-status tw-flex tw-items-center tw-text-[11px] tw-font-[500] tw-rounded-[4px]"]),
                    "data-cy": `vendor-assessment-history-status-${item.checklistRequestedId}`
                  }, [
                    _createElementVNode("span", null, _toDisplayString(statusAssessment[item.statusId]?.label), 1)
                  ], 10, _hoisted_18)
                ]))
              : (_openBlock(), _createElementBlock("div", {
                  key: 1,
                  class: "tw-px-[5px] tw-py-[3px] cell-status tw-flex tw-items-center tw-text-[11px] tw-font-[500] tw-rounded-[4px] tw-border-solid tw-border-[1px] tw-border-[#FEE5E2] tw-text-[#F7553C]",
                  "data-cy": `vendor-assessment-history-status-${item.checklistRequestedId}`
                }, [
                  _createElementVNode("span", null, _toDisplayString(_unref(getComponentUiText)(
                "app-component-assessments-checklists-requested-status-deleted-1",
              )), 1)
                ], 8, _hoisted_19)),
            _createVNode(popoverAssessment, {
              ref_for: true,
              ref_key: "popoverAssessmentRef",
              ref: popoverAssessmentRef,
              "style-button": "!tw-py-[8px] !tw-px-[8px] tw-ml-[-8px] tw-mr-[-8px] tw-items-center tw-justify-center",
              offset: 20,
              "id-popover": 
              'popover-assessment-vendor-history-' + item.checklistRequestedId
            ,
              "data-cy-id": 
              'popover-assessment-vendor-history-' + item.checklistRequestedId
            ,
              "b-popover": `popover-has-tag`
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subMenuOptions.value, (option) => {
                  return (_openBlock(), _createBlock(CustomDropDownItem, {
                    id: `verdor-assessment-popover-item-${option.id}-${item.checklistRequestedId}`,
                    key: `option_vendor_assessment_history_${option.id}`,
                    "is-show-option": option.isShow(item),
                    "id-text": `${option.text(item)}`,
                    "data-cy-id": option.dataCy(item),
                    "custom-text-class": `tw-flex tw-items-center tw-gap-[5px] tw-w-[90%] !tw-text-[13px] !tw-font-normal !tw-leading-[19.5px] ${
                option.arrowRed ? 'tw-text-[#F7553C]' : ''
              } tw-whitespace-normal`,
                    "arrow-icon-style": `${
                option.arrowRed ? 'tw-text-[#F7553C]' : 'tw-text-[#387DFF]'
              } tw-min-w-[7px]`,
                    padding: 'tw-px-[13px] tw-py-[12px]',
                    "custom-class": 'tw-flex tw-justify-between tw-items-center !tw-border-0',
                    "tag-status": option.statusTag,
                    "tag-status-id": option.statusTagId,
                    onClick: ($event: any) => (option.action(item))
                  }, null, 8, ["id", "is-show-option", "id-text", "data-cy-id", "custom-text-class", "arrow-icon-style", "tag-status", "tag-status-id", "onClick"]))
                }), 128))
              ]),
              _: 2
            }, 1032, ["id-popover", "data-cy-id"])
          ])
        ]))
      }), 128))
    ], 512), [
      [_vShow, !showIcon.value]
    ])
  ]))
}
}

})